import { z } from 'zod';
import type { $brand } from 'zod/v4/core';

export type PracticeId = string & $brand<'PracticeId'>;
export const practiceIdSchema = z.uuid().transform((id) => id as PracticeId);

export type PracticeMemberId = string & $brand<'PracticeMemberId'>;
export const practiceMemberIdSchema = z.uuid().transform((id) => id as PracticeMemberId);

export type PracticeMemberLicenseId = string & $brand<'PracticeMemberLicenseId'>;
export const practiceMemberLicenseIdSchema = z
    .uuid()
    .transform((id) => id as PracticeMemberLicenseId);

export type PracticeLocationId = string & $brand<'PracticeLocationId'>;
export const practiceLocationIdSchema = z.uuid().transform((id) => id as PracticeLocationId);

export type SessionId = string & $brand<'SessionId'>;
export const sessionIdSchema = z.uuid().transform((id) => id as SessionId);

export type ClientId = string & $brand<'ClientId'>;
export const clientIdSchema = z.uuid().transform((id) => id as ClientId);
